import HeaderTab from './HeaderTab'

export default HeaderTab
